// define a mixin object
import {mapActions, mapGetters, mapMutations} from 'vuex'

import {findIndex, propEq} from 'ramda'

export const notificationMixin = {
  computed: {
    ...mapGetters({
      'notifications': 'notifications/all'
    })
  },
  methods: {
    ...mapMutations({
      'commitNotification': 'notifications/addNotification',
      'resetNotifications': 'notifications/resetNotifications'
    }),
    ...mapActions({
      'resetNotificationsAction': 'notifications/resetNotificationsAction'
    }),
    addNotification (type, text) {
      if (text === '403 - Authentication failed.') {
        text = 'Session ended, please log back in.'
      }
      const notification = {
        id: this.uniqueId(),
        type: type,
        date: new Date().getTime(),
        show: true,
        message: {
          body: text
        }
      }
      this.commitNotification(notification)
      return notification
    },
    closeLastNotification (id) {
      const index = findIndex(propEq('id', id))(this.notifications)
      this.notifications[index].show = false
    },
    uniqueId () {
      return Math.random().toString(36).substr(2, 10)
    }
  },
  watch: {
    $route (from) {
      // some pages we need to show notifications when changing routes
      if (!from.query.notification) {
        this.resetNotifications()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/notificationMixin.js